import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getSalesInvoiceList = createAsyncThunk(
  "get-sales-invoice",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("invoice/list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createSalesInvoice = createAsyncThunk(
  "create-sales-invoice",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("invoice", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdSalesInvoice = createAsyncThunk(
  "edit-sales-invoice",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`invoice/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateSalesInvoice = createAsyncThunk(
  "update-sales-invoice",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/invoice/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateSalesInvoiceFlag = createAsyncThunk(
  "update-sales-invoice-flag",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/invoice/flag/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteSalesInvoice = createAsyncThunk(
  "delete-sales-invoice",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/invoice/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const salesInvoiceSlice = createSlice({
  name: "sales-invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesInvoiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesInvoiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.invoiceList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getSalesInvoiceList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default salesInvoiceSlice.reducer;
